import React, { useMemo } from "react";
import { SvgIcon } from "./SvgIcon";
// @ts-ignore — qrcode-generator has no shipping types
import qrcodeGen from "qrcode-generator";

type Props = {
  value: string;
  size?: number;
  // Foreground / background colors. Defaults to dark-on-cream so the QR
  // contrasts on the apricot Kidly background while staying scannable.
  fg?: string;
  bg?: string;
};

// Render a QR code as an inline SVG data URI. Used on the TV (where we want
// to show parents a scannable link to the web companion).
//
// `value` should be a fully-qualified URL — phones won't scan-and-act on a
// bare path or string. Use the parent web's LAN address in dev, or the
// production app URL in prod.
export function QrCode({
  value,
  size = 240,
  fg = "#2E2316",
  bg = "#FFFFFF",
}: Props) {
  const svg = useMemo(() => {
    // Type "0" lets the library pick the smallest version that fits.
    // Error correction "M" survives some occlusion from camera glare.
    const qr = qrcodeGen(0, "M");
    qr.addData(value);
    qr.make();
    const moduleCount: number = qr.getModuleCount();
    // Build an SVG path of dark cells. One <rect> per cell would be huge;
    // a single path with subpath segments compresses much better.
    let path = "";
    for (let r = 0; r < moduleCount; r++) {
      for (let c = 0; c < moduleCount; c++) {
        if (qr.isDark(r, c)) {
          path += `M${c} ${r}h1v1h-1z`;
        }
      }
    }
    return (
      `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${moduleCount} ${moduleCount}" shape-rendering="crispEdges">` +
      `<rect width="${moduleCount}" height="${moduleCount}" fill="${bg}"/>` +
      `<path d="${path}" fill="${fg}"/>` +
      `</svg>`
    );
  }, [value, fg, bg]);

  return <SvgIcon svg={svg} width={size} height={size} />;
}

export default QrCode;
